/**
* DevExpress Analytics (widgets\ace\_ace-available.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ace_1 = require("ace-builds/src-noconflict/ace");
exports.aceAvailable = createGlobalAceVariableFunc();
function createGlobalAceVariableFunc() {
    var currentValue;
    return function (newVal) {
        if (newVal !== undefined)
            currentValue = newVal;
        return currentValue === undefined ? !!ace_1.default : currentValue;
    };
}
